import { patientDetailStore } from '@patientMenu/store/patientDetailStore';

export const usePatientDetailStore = () => {
  const selectedScan = patientDetailStore((state) => state.selectedScan);
  const setSelectedScan = patientDetailStore((state) => state.setSelectedScan);

  return {
    selectedScan,
    setSelectedScan,
  };
};
